import { Box, Typography, useTheme } from '@mui/material';

type HeaderStatsItemProps = {
  label: string;
  value: number | null;
  isLoading: boolean;
  icon: React.ReactNode;
};

export const HeaderStatsItem = (props: HeaderStatsItemProps) => {
  const { label, value, icon } = props;
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(2) }}>
      <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>{icon}</Box>
      <Typography fontSize={15}>
        {label}: {value ?? '--'}
      </Typography>
    </Box>
  );
};
